import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../../App";
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { handleUserLevelAccessPermissions, validateRolesIIPHQ, shortMonthToFull } from "../../../../../Custom/Custom";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { IIPIndexReport } from "../../ExportIIPExcel";
import iipTitleData from '../../../../../iip.json';
import iipFieldTitleData from '../../../../../titles.json';
import messages from '../../.././../../assets/Messages.json';
import { changeDateFormat } from "../../../../../Custom/Custom";

const IndexReport = () => {
  const [years, setYears] = useState([]);
  const [surveyYear, setSurveyYear] = useState([]);
  const [yearName, setYearName] = useState("");
  const [yearsName, setYearsName] = useState("");

  const [months, setMonths] = useState([]);
  const [monthName, setMonthName] = useState("");
  const [reportType, setReportType] = useState("");

  const [halfYearlyMonth, setHalfYearlyMonth] = useState("");
  const [quarterlyMonth, setQuarterlyMonth] = useState("");

  const [annualUBCategorisationReport, setAnnualUBCategorisationReport] = useState([]);
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });
  const [yearNameNextTitle, setYearNameNextTitle] = useState([]);
  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const navigate = useNavigate();
  const config = getAuthHeaders();


  const storedLanguage = localStorage.getItem('language');



  const getAllYears = () => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = currentYear; year >= 2021; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };


  //get next Years 
  const getNextYear = (year) => {
    const nextYear = parseInt(year) + 1;
    return `${year}-${nextYear}`;
  };


  const getSurveyYear = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); 
    const currentFinancialYearStart = currentMonth < 3 ? currentYear - 1 : currentYear;
    
  
    const yearsArray = [];
    for (let year = currentFinancialYearStart; year >= 2021; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };

  const getMonthsList = () => {
    showLoading(true);
    axios
      .get(`${API_URL}api/graph/getMonths/2019`, config)
      .then((res) => {
        let monthDataResponse = res.data;
        console.warn("PPPPPPPPP", monthDataResponse);

        if (monthDataResponse.status) {
          const monthList = monthDataResponse.data.map(item => item.MONTH);
          setMonths(monthList);

        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        showLoading(false);
      });
  };

  const getReportTypes = () => [
    { value: "Annual", label: "Annual Report" },
    { value: "Nine_Months", label: "Nine Month Report" },
    { value: "Half-Yearly", label: "Half Yearly Report" },
    { value: "Quarterly", label: "Quarterly Report" },
    { value: "Monthly", label: "Monthly Report" },
  ];


  //Half Yearly Report Month 

  const getHalfYearlyMonth = () => [
    { value: "Apr-Sep", label: "Apr-Sep" },
    { value: "Oct-Mar", label: "Oct-Mar" },
  ];


  //Quarterly Report Month

  const getQuarterlyMonth = () => [
    { value: "Apr-Jun", label: "Apr-Jun" },
    { value: "Jul-Sep", label: "Jul-Sep" },
    { value: "Oct-Dec", label: "Oct-Dec" },
    { value: "Jan-Mar", label: "Jan-Mar" }
  ];


  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
    const getYearList = () => {
      setYears(getAllYears());
    };

    const getSurveyYearList = () => {
      setSurveyYear(getSurveyYear());
    };

    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRolesIIPHQ(decode_token);
        if (role) {
          getYearList();
          getSurveyYearList();
          getMonthsList(); // Fetch months when component mounts
          getReportTypes();
          getHalfYearlyMonth();

        } else {
          alert(
            "You are not an authorized for IIP Report."
          );
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      } finally {
        showLoading(false);
      }
    };

    userRole();
  }, []);

 

  const handleYearChange = (e) => {
    setYearName(e.target.value);
  };


  const handleSurveyYearsChange = (e) => {
    setYearsName(e.target.value);
  };

  const handleMonthChange = (e) => {
    setMonthName(e.target.value);
  };

  const MONTH_ORDER = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  const formatMonthYearShort = (month, year) => {
    const monthText = String(month || '').trim().toUpperCase();
    const monthLabel = monthText ? `${monthText.charAt(0)}${monthText.slice(1).toLowerCase()}` : 'NA';
    const yearText = String(year || '');
    const yy = yearText.length >= 2 ? yearText.slice(-2) : yearText;
    return `${monthLabel}-${yy}`;
  };
  const getPreviousMonthYear = (month, year) => {
    const monthText = String(month || '').trim().toUpperCase();
    const yearNum = parseInt(year, 10);
    const monthIndex = MONTH_ORDER.indexOf(monthText);
    if (monthIndex === -1 || !Number.isFinite(yearNum)) {
      return { month: monthText || '', year: String(year || '') };
    }
    if (monthIndex === 0) {
      return { month: 'DEC', year: String(yearNum - 1) };
    }
    return { month: MONTH_ORDER[monthIndex - 1], year: String(yearNum) };
  };
  const formatFinancialYearLabel = (startYear) => {
    const y = parseInt(startYear, 10);
    if (!Number.isFinite(y)) return String(startYear || '');
    return `${y}-${String(y + 1).slice(-2)}`;
  };
  const getPreviousHalfYearLabel = (halfYearLabel) => {
    if (halfYearLabel === 'Apr-Sep') return 'Oct-Mar';
    if (halfYearLabel === 'Oct-Mar') return 'Apr-Sep';
    return halfYearLabel || '';
  };
  const getPreviousQuarterInfo = (quarterLabel, currentYearStart) => {
    const q = String(quarterLabel || '').trim();
    const y = parseInt(currentYearStart, 10);
    if (!Number.isFinite(y)) {
      return { quarter: q, yearStart: String(currentYearStart || '') };
    }
    switch (q) {
      case 'Apr-Jun':
        return { quarter: 'Jan-Mar', yearStart: String(y - 1) };
      case 'Jul-Sep':
        return { quarter: 'Apr-Jun', yearStart: String(y) };
      case 'Oct-Dec':
        return { quarter: 'Jul-Sep', yearStart: String(y) };
      case 'Jan-Mar':
        return { quarter: 'Oct-Dec', yearStart: String(y) };
      default:
        return { quarter: q, yearStart: String(y) };
    }
  };
  const parseNumber = (val) => {
    if (val === null || val === undefined || val === '') return null;
    const num = Number(val);
    return Number.isFinite(num) ? num : null;
  };
  const getVariationPercent = (currentIndexRaw, referenceIndexRaw) => {
    const current = parseNumber(currentIndexRaw);
    const reference = parseNumber(referenceIndexRaw);
    if (current === null || reference === null) return '';
    let variation = 0;
    if (reference === 0) variation = current === 0 ? 0 : 100;
    else variation = ((current - reference) / reference) * 100;
    // normalize floating noise (avoid showing -0.00%)
    if (Math.abs(variation) < 1e-9) variation = 0;
    return `${variation.toFixed(2)}%`;
  };


  const fetchReportData = async (postData) => {
    showLoading(true);
    try {
      let endpoint = '';
      const payload = { ...postData };

      if (reportType === 'Monthly') {
        endpoint = `${API_URL}api/iipReports/HQReports/IIPMonthlyIndexReport`;
        payload.month = monthName || "Apr"; 
        payload.year = yearName || "2024";
        delete payload.monthDuration;
        delete payload.Year; 
      } else {
        endpoint = `${API_URL}api/iipReports/HQReports/IIpIndexReport`;
        payload.monthDuration = postData.monthDuration;
        payload.Year = postData.Year;
        delete payload.month;
      }
     const response = await axios.post(endpoint, payload, config);
     let allData = [];

      if (reportType === 'Monthly') {
        // API shape: { status, message, data: { MonthlyReportDataList: [...] } }
        const monthlyList = response.data?.data?.MonthlyReportDataList;
        allData = Array.isArray(monthlyList)
          ? monthlyList.reduce((acc, data) => acc.concat(data.Items || []), [])
          : [];

     } else {
        allData = response.data.data?.MajorReportDataList || [];
      }



      if (response.data.status) {
        if (allData.length > 0) {
          let runningSNo = 0;
          const mappedData = allData.map((item) => {
            const nic5d = item.nic5d ?? item.NIC5d ?? item.NIC5D ?? '';
            const hasNic5d = String(nic5d ?? '').trim() !== '';
            const sNo = hasNic5d ? ++runningSNo : '';
            const currentIndex = item.index ?? item.IndexI ?? '';
            const prevMonthIndex = item.previousMonthData?.IndexI ?? '';
            const prevYearIndex = item.previousYearData?.IndexI ?? '';
            return ({
              SNo: sNo,
              NIC3d: item.nic3d ?? item.NIC3d ?? item.NIC3D ?? '',
              NIC4d: item.nic4d ?? item.NIC4d ?? item.NIC4D ?? '',
              NIC5d: nic5d,
              Item: item.item ?? item.Item ?? '',
              NPCMSCode: item.npcms_code ?? item.npcmsCode ?? item.NPCMS_CODE ?? item.NPCMSCode ?? '',
              NIC2d: item.nic2d ?? item.NIC2d ?? item.NIC2D ?? '',
              ItemName: item.item_name ?? item.itemName ?? item.ItemName ?? '',
              Weight: item.weight ?? item.Weight ?? '',
              Units: item.unit_name ?? item.unitName ?? item.Units ?? '',
              BPQty: item.base_year_price ?? item.bp ?? item.BPQty ?? '',
              CPQty: item.cp ?? item.CPQty ?? '',
              IndexI: currentIndex,
              IndexWt: item.index_wt ?? item.indexWt ?? item.IndexWt ?? '',
              PrevMonthBPQty: item.previousMonthData?.BPQty ?? '',
              PrevMonthCPQty: item.previousMonthData?.CPQty ?? '',
              PrevMonthIndexI: item.previousMonthData?.IndexI ?? '',
              PrevMonthIndexWt: item.previousMonthData?.IndexWt ?? '',
              PrevMonthVariation: getVariationPercent(currentIndex, prevMonthIndex),
              PrevYearBPQty: item.previousYearData?.BPQty ?? '',
              PrevYearCPQty: item.previousYearData?.CPQty ?? '',
              PrevYearIndexI: item.previousYearData?.IndexI ?? '',
              PrevYearIndexWt: item.previousYearData?.IndexWt ?? '',
              PrevYearVariation: getVariationPercent(currentIndex, prevYearIndex),
            });
          });
          setAnnualUBCategorisationReport(mappedData);
          return mappedData;
        } else {
          console.warn('No data found for the specified parameters.');
          toast.info('No data found for the specified parameters.');
        }
      } else {
        console.error('Error in API response:', response.data.message);
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
      toast.error('An error occurred while fetching data.');
    } finally {
      showLoading(false);
    }
    return [];
  };



  const handleGenerateExcel = async () => {

    if (reportType === 'Monthly') {
      if (!yearName) {
        toast.error('Please select a year.', messages.COLOR_RED);
        return;
      }
      if (!monthName) {
        toast.error('Please select a month.', messages.COLOR_RED);
        return;
      }
    } else if (reportType === 'Half-Yearly') {
      if (!yearsName) {
        toast.error('Please select a year.', messages.COLOR_RED);
        return;
      }
      if (!halfYearlyMonth) {
        toast.error('Please select a half-yearly month.', messages.COLOR_RED);
        return;
      }
    } else if (reportType === 'Quarterly') {
      if (!yearsName) {
        toast.error('Please select a year.', messages.COLOR_RED);
        return;
      }
      if (!quarterlyMonth) {
        toast.error('Please select a quarterly month.', messages.COLOR_RED);
        return;
      }
    } else if (reportType === 'Annual' || reportType === 'Nine_Months') {
      if (!yearsName) {
        toast.error('Please select a year.', messages.COLOR_RED);
        return;
      }
    } else {
      toast.error('Please select a report type.', messages.COLOR_RED);
      return;
    }
    // Set default month if not selected
    // const selectedMonth = monthName || "Apr";
    // const postData = { reportType: reportType, Year: yearName || yearsName, monthDuration: selectedMonth };

    const postData = {
      reportType: reportType,
      Year: yearName || yearsName,
      monthDuration: (reportType === 'Half-Yearly' ? halfYearlyMonth : (reportType === 'Quarterly' ? quarterlyMonth : '')),
      month: (reportType === 'Monthly' ? monthName : '')
    };

    const reportData = await fetchReportData(postData);

    if (reportData.length > 0) {


      let excelFileName = `IndexReport_${reportType}`;

      if (reportType === 'Monthly') {
        excelFileName += `_${monthName}_${yearName}`;
      } else if (reportType === 'Half-Yearly') {
        excelFileName += `_${halfYearlyMonth}_${yearsName}`;
      } else if (reportType === 'Quarterly') {
        excelFileName += `_${quarterlyMonth}_${yearsName}`;
      } else {
        excelFileName += `_${yearsName}`;
      }

      let fourthRowText = '';

      switch (reportType) {
        case 'Monthly':
          fourthRowText = `Monthly Report - ${monthName} (${yearName})`;
          break;
        case 'Half-Yearly':
          fourthRowText = `Half-Yearly Report - ${halfYearlyMonth} (${yearsName} - ${parseInt(yearsName) + 1})`;
          break;
        case 'Quarterly':
          fourthRowText = `Quarterly Report - ${quarterlyMonth} (${yearsName} - ${parseInt(yearsName) + 1})`;
          break;
        case 'Annual':
          fourthRowText = `Annual Report - (${yearsName} - ${parseInt(yearsName) + 1})`;
          break;
        case 'Nine_Months':
          fourthRowText = `Nine Months Report - (${yearsName} - ${parseInt(yearsName) + 1})`;
          break;
        default:
          fourthRowText = `Report - ${yearsName}`;
          break;
      }

      let excelObjectData = {
        fileName: excelFileName,
        reportType: excelFileName,
        fileType: 'xls',
        sheetName: "IIPIndexReport",
        // Previous period highlighting (matches UBReport screenshot colors)
        previousMonthHighlightColor: 'ADD8E6',
        previousYearHighlightColor: 'FFE4B5',
        firstRowMergeCells: "A1:N1",
        firstRowExportData: changeDateFormat(new Date()),
        firstRowCellNumber: 14,
        secondRowMergeCells: "A2:N2",
        secondRowText: 'ECONOMICS & STATISTICS DIVISION, UTTAR PRADESH',
        thirdRowMergeCells: "A3:N3",
        thirdRowText: 'COMPUTATION OF INDUSTRIAL PRODUCTION INDEX  U.P 2011-12=100',
        fourthRowMergeCells: "A4:N4",
        fourthRowText: fourthRowText,
        fifthRowMergeCells: "A5:N5",
        fifthRowText: "MANUFACTURING SECTOR",
        headerEnglishColumns: [
          'S.No', 'NIC-3d', 'NIC-4d', 'NIC-5d', 'Item', 'NPCMS Code', 'NIC-2d', 'Item Name', 'Weight', 'Units', 'B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt'
        ],

        excelRowData: reportData.map(item => [
          item.SNo,
          item.NIC3d,
          item.NIC4d,
          item.NIC5d,
          item.Item,
          item.NPCMSCode,
          item.NIC2d,
          item.ItemName,
          item.Weight,
          item.Units,
          item.BPQty,
          item.CPQty,
          item.IndexI,
          item.IndexWt 
        ]),
      };

      if (reportType === 'Monthly') {
        const currentLabel = formatMonthYearShort(monthName, yearName);
        const prevMonthInfo = getPreviousMonthYear(monthName, yearName);
        const previousMonthLabel = formatMonthYearShort(prevMonthInfo.month, prevMonthInfo.year);
        const previousYearLabel = formatMonthYearShort(monthName, String((parseInt(yearName, 10) || 0) - 1));

        excelObjectData = {
          ...excelObjectData,
          firstRowMergeCells: "A1:V1",
          secondRowMergeCells: "A2:V2",
          thirdRowMergeCells: "A3:V3",
          fourthRowMergeCells: "A4:V4",
          fifthRowMergeCells: "A5:V5",
          thirdRowText: 'MANUFACTURING SECTOR',
          groupedHeader: {
            fixedHeaders: ['S.No', 'NIC-3d', 'NIC-4d', 'NIC-5d', 'Item', 'NPCMS Code', 'NIC-2d', 'Item Name', 'Weight', 'Units'],
            groups: [
              { title: currentLabel, columns: ['B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt'] },
              { title: previousMonthLabel, columns: ['B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt', 'Variation %'] },
              { title: previousYearLabel, columns: ['B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt', 'Variation %'] },
            ],
          },
          excelRowData: reportData.map(item => [
            item.SNo,
            item.NIC3d,
            item.NIC4d,
            item.NIC5d,
            item.Item,
            item.NPCMSCode,
            item.NIC2d,
            item.ItemName,
            item.Weight,
            item.Units,
            item.BPQty,
            item.CPQty,
            item.IndexI,
            item.IndexWt,
            item.PrevMonthBPQty,
            item.PrevMonthCPQty,
            item.PrevMonthIndexI,
            item.PrevMonthIndexWt,
            item.PrevMonthVariation,
            item.PrevYearBPQty,
            item.PrevYearCPQty,
            item.PrevYearIndexI,
            item.PrevYearIndexWt,
            item.PrevYearVariation,
          ]),

         
        
        };
      }
      if (reportType === 'Half-Yearly') {
        const currentYearStart = yearsName || yearName;
        const currentFyLabel = formatFinancialYearLabel(currentYearStart);
        const previousFyLabel = formatFinancialYearLabel((parseInt(currentYearStart, 10) || 0) - 1);
        const currentHalfLabel = halfYearlyMonth || '';
        const previousHalfLabel = getPreviousHalfYearLabel(currentHalfLabel);

        excelObjectData = {
          ...excelObjectData,
          firstRowMergeCells: "A1:X1",
          secondRowMergeCells: "A2:X2",
          thirdRowMergeCells: "A3:X3",
          fourthRowMergeCells: "A4:X4",
          fifthRowMergeCells: "A5:X5",
          groupedHeader: {
            fixedHeaders: ['S.No', 'NIC-3d', 'NIC-4d', 'NIC-5d', 'Item', 'NPCMS Code', 'NIC-2d', 'Item Name', 'Weight', 'Units'],
            groups: [
              { title: `${currentFyLabel} ${currentHalfLabel}`.trim(), columns: ['B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt'] },
              { title: `${currentFyLabel} ${previousHalfLabel}`.trim(), columns: ['B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt', 'Variation %'] },
              { title: `${previousFyLabel} ${currentHalfLabel}`.trim(), columns: ['B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt', 'Variation %'] },
            ],
          },
          excelRowData: reportData.map(item => [
            item.SNo,
            item.NIC3d,
            item.NIC4d,
            item.NIC5d,
            item.Item,
            item.NPCMSCode,
            item.NIC2d,
            item.ItemName,
            item.Weight,
            item.Units,
            item.BPQty,
            item.CPQty,
            item.IndexI,
            item.IndexWt,
            item.PrevMonthBPQty,
            item.PrevMonthCPQty,
            item.PrevMonthIndexI,
            item.PrevMonthIndexWt,
            item.PrevMonthVariation,
            item.PrevYearBPQty,
            item.PrevYearCPQty,
            item.PrevYearIndexI,
            item.PrevYearIndexWt,
            item.PrevYearVariation,
          ]),
        };
      } else if (reportType === 'Quarterly') {
        const currentYearStart = yearsName || yearName;
        const currentFyLabel = formatFinancialYearLabel(currentYearStart);
        const previousFyLabel = formatFinancialYearLabel((parseInt(currentYearStart, 10) || 0) - 1);
        const currentQuarterLabel = quarterlyMonth || '';
        const previousQuarterInfo = getPreviousQuarterInfo(currentQuarterLabel, currentYearStart);
        const previousQuarterFyLabel = formatFinancialYearLabel(previousQuarterInfo.yearStart);

        excelObjectData = {
          ...excelObjectData,
          firstRowMergeCells: "A1:X1",
          secondRowMergeCells: "A2:X2",
          thirdRowMergeCells: "A3:X3",
          fourthRowMergeCells: "A4:X4",
          fifthRowMergeCells: "A5:X5",
          groupedHeader: {
            fixedHeaders: ['S.No', 'NIC-3d', 'NIC-4d', 'NIC-5d', 'Item', 'NPCMS Code', 'NIC-2d', 'Item Name', 'Weight', 'Units'],
            groups: [
              { title: `${currentFyLabel} ${currentQuarterLabel}`.trim(), columns: ['B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt'] },
              { title: `${previousQuarterFyLabel} ${previousQuarterInfo.quarter}`.trim(), columns: ['B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt', 'Variation %'] },
              { title: `${previousFyLabel} ${currentQuarterLabel}`.trim(), columns: ['B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt', 'Variation %'] },
            ],
          },
          excelRowData: reportData.map(item => [
            item.SNo,
            item.NIC3d,
            item.NIC4d,
            item.NIC5d,
            item.Item,
            item.NPCMSCode,
            item.NIC2d,
            item.ItemName,
            item.Weight,
            item.Units,
            item.BPQty,
            item.CPQty,
            item.IndexI,
            item.IndexWt,
            item.PrevMonthBPQty,
            item.PrevMonthCPQty,
            item.PrevMonthIndexI,
            item.PrevMonthIndexWt,
            item.PrevMonthVariation,
            item.PrevYearBPQty,
            item.PrevYearCPQty,
            item.PrevYearIndexI,
            item.PrevYearIndexWt,
            item.PrevYearVariation,
          ]),
        };
      } else if (reportType === 'Annual' || reportType === 'Nine_Months') {
        const currentYearStart = yearsName || yearName;
        const currentFyLabel = formatFinancialYearLabel(currentYearStart);
        const previousFyLabel = formatFinancialYearLabel((parseInt(currentYearStart, 10) || 0) - 1);
        excelObjectData = {
          ...excelObjectData,
          firstRowMergeCells: "A1:S1",
          secondRowMergeCells: "A2:S2",
          thirdRowMergeCells: "A3:S3",
          fourthRowMergeCells: "A4:S4",
          fifthRowMergeCells: "A5:S5",
          groupedHeader: {
            fixedHeaders: ['S.No', 'NIC-3d', 'NIC-4d', 'NIC-5d', 'Item', 'NPCMS Code', 'NIC-2d', 'Item Name', 'Weight', 'Units'],
            groups: [
              { title: currentFyLabel, columns: ['B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt'] },
              { title: previousFyLabel, columns: ['B.P.(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt', 'Variation %'] },
            ],
          },
          excelRowData: reportData.map(item => [
            item.SNo,
            item.NIC3d,
            item.NIC4d,
            item.NIC5d,
            item.Item,
            item.NPCMSCode,
            item.NIC2d,
            item.ItemName,
            item.Weight,
            item.Units,
            item.BPQty,
            item.CPQty,
            item.IndexI,
            item.IndexWt,
            item.PrevYearBPQty,
            item.PrevYearCPQty,
            item.PrevYearIndexI,
            item.PrevYearIndexWt,
            item.PrevYearVariation,
          ]),
        };
      }

      IIPIndexReport(excelObjectData);
    }
  };

  const handleReportTypeChange = (e) => {
    const selectedReportType = e.target.value;
    setReportType(selectedReportType);
    setMonthName(""); 
    setYearName(""); 
    setHalfYearlyMonth(""); 
    setQuarterlyMonth(""); 
  };

  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                {/* <h3 style={{ color: '#F47720' }}>Index of Industrial Production, Uttar Pradesh</h3>
                (Manufacturing Sector- Index Report) */}
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.INDEX_REPORT : iipTitleData.en.INDEX_REPORT }} />
              </h4>

              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">Select Report</label>
                  <select
                    name="report_type"
                    className="form-select"
                    onChange={handleReportTypeChange}
                    value={reportType}
                  >
                    <option value="" disabled>Select Report Type</option>
                    {getReportTypes().map((type, index) => (
                      <option key={index} value={type.value}>{type.label}</option>
                    ))}
                  </select>
                </div>

                {reportType === "Monthly" && (
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label className="fw-bold h6">Year</label>
                    <select
                      name="year_name"
                      className="form-select"
                      onChange={handleYearChange}
                      value={yearName}
                    >
                      <option value="" disabled>Select Year</option>
                      {years &&
                        years.map((ele, index) => (
                          <option key={index} value={ele}>
                            {ele}
                          </option>
                        ))}
                    </select>
                  </div>
                )}

                {(reportType === "Annual" || reportType === "Nine_Months") && (
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label className="fw-bold h6">Select Year</label>
                    <select
                      name="year_name"
                      className="form-select"
                      onChange={handleSurveyYearsChange}
                      value={yearsName}
                    >
                      <option value="" disabled>Select Year</option>
                      {surveyYear &&
                        surveyYear.map((ele, index) => (
                          <option key={index} value={ele}>
                            {getNextYear(ele)}
                          </option>
                        ))}
                    </select>
                  </div>
                )}

                {reportType === "Half-Yearly" && (
                  <>
                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                      <label className="fw-bold h6">Select Year</label>
                      <select
                        name="year_name"
                        className="form-select"
                        onChange={handleSurveyYearsChange}
                        value={yearsName}
                      >
                        <option value="" disabled>Select Year</option>
                        {surveyYear &&
                          surveyYear.map((ele, index) => (
                            <option key={index} value={ele}>
                              {getNextYear(ele)}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                      <label className="fw-bold h6">Select Month</label>
                      <select
                        name="half_yearly_month"
                        className="form-select"
                        onChange={(e) => setHalfYearlyMonth(e.target.value)}
                        value={halfYearlyMonth}
                      >
                        <option value="" disabled>Select Month</option>
                        {getHalfYearlyMonth().map((type, index) => (
                          <option key={index} value={type.value}>{type.label}</option>
                        ))}
                      </select>
                    </div>
                  </>
                )}

                {reportType === "Quarterly" && (
                  <>
                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                      <label className="fw-bold h6">Select Year</label>
                      <select
                        name="year_name"
                        className="form-select"
                        onChange={handleSurveyYearsChange}
                        value={yearsName}
                      >
                        <option value="" disabled>Select Year</option>
                        {surveyYear &&
                          surveyYear.map((ele, index) => (
                            <option key={index} value={ele}>
                              {getNextYear(ele)}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                      <label className="fw-bold h6">Select Month Quarter</label>
                      <select
                        name="quarterly_month"
                        className="form-select"
                        onChange={(e) => setQuarterlyMonth(e.target.value)}
                        value={quarterlyMonth}
                      >
                        <option value="" disabled>Select Month</option>
                        {getQuarterlyMonth().map((type, index) => (
                          <option key={index} value={type.value}>{type.label}</option>
                        ))}
                      </select>
                    </div>
                  </>
                )}

                {reportType === "Monthly" && (
                  <>
                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                      <label className="fw-bold h6">Month</label>
                      <select
                        name="month_name"
                        className="form-select"
                        onChange={handleMonthChange}
                        value={monthName}
                      >
                        <option value="" disabled>Select Month</option>
                        {months &&
                          months.map((ele, index) => (
                            <option key={index} value={ele}>
                              {shortMonthToFull(ele)}
                            </option>
                          ))}
                      </select>
                    </div>
                  </>
                )}

                {(reportType === "Annual" || reportType === "Nine_Months" || reportType === "Half-Yearly" || reportType === "Quarterly" || reportType === "Monthly") && (
                  <div className="col-xl-2 col-lg-12 mb-3">
                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                    <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndexReport;